import { isPushSupported, readPushPermission } from './pushNotifications';

const dismissedKey = (audience) => `salovare.pushPrompt.${audience}`;

const promptListeners = new Set();
const enabledListeners = new Set();

export const isPushPromptDismissed = (audience) => {
  try {
    return window.localStorage.getItem(dismissedKey(audience)) === 'dismissed';
  } catch (error) {
    return false;
  }
};

export const dismissPushPrompt = (audience) => {
  try {
    window.localStorage.setItem(dismissedKey(audience), 'dismissed');
  } catch (error) {
    // Private browsing can reject storage writes. The prompt can show again next time.
  }
};

export const shouldAutoOpenPushPrompt = (audience) => (
  isPushSupported()
  && readPushPermission() === 'default'
  && !isPushPromptDismissed(audience)
);

export const openPushPrompt = (audience) => {
  promptListeners.forEach((listener) => listener(audience));
};

export const subscribePushPrompt = (listener) => {
  promptListeners.add(listener);
  return () => promptListeners.delete(listener);
};

export const notifyPushEnabled = (audience) => {
  enabledListeners.forEach((listener) => listener(audience));
};

export const subscribePushEnabled = (listener) => {
  enabledListeners.add(listener);
  return () => enabledListeners.delete(listener);
};
